export default "__VITE_PUBLIC_ASSET__4b546933__"